/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Orgmanagerv1NoteType } from '../models/Orgmanagerv1NoteType';
import { HttpFile } from '../http/http';

export class AdvertisingPlatformServiceCreateOrgNoteRequest {
    'type'?: Orgmanagerv1NoteType;
    'content'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "Orgmanagerv1NoteType",
            "format": ""
        },
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServiceCreateOrgNoteRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

